import { z } from 'zod'

export const REASON_CODES = [
  { value: 'forgot_punch', label: 'Forgot to punch' },
  { value: 'wrong_time', label: 'Wrong time entered' },
  { value: 'other', label: 'Other' },
] as const

export const timeCorrectionRequestFormSchema = z
  .object({
    reason: z.string().min(1, 'Reason is required'),
    requestedClockInDate: z.string().optional(),
    requestedClockInTime: z.string().optional(),
    requestedClockOutDate: z.string().optional(),
    requestedClockOutTime: z.string().optional(),
    reasonCode: z.string().optional(),
  })
  .refine(
    (data) => {
      const hasClockIn = !!(data.requestedClockInDate && data.requestedClockInTime)
      const hasClockOut = !!(data.requestedClockOutDate && data.requestedClockOutTime)
      return hasClockIn || hasClockOut
    },
    { message: 'Provide at least clock-in or clock-out date and time', path: ['requestedClockInDate'] }
  )
  .refine(
    (data) => {
      if (
        !data.requestedClockInDate ||
        !data.requestedClockInTime ||
        !data.requestedClockOutDate ||
        !data.requestedClockOutTime
      ) {
        return true
      }
      const inStr = `${data.requestedClockInDate}T${data.requestedClockInTime}:00`
      const outStr = `${data.requestedClockOutDate}T${data.requestedClockOutTime}:00`
      return new Date(outStr) > new Date(inStr)
    },
    { message: 'Clock-out must be after clock-in', path: ['requestedClockOutDate'] }
  )

export type TimeCorrectionRequestFormData = z.infer<typeof timeCorrectionRequestFormSchema>

export function buildTimeCorrectionRequestDto(
  data: TimeCorrectionRequestFormData,
  attendanceId: string
): {
  attendanceId: string
  reason: string
  requestedClockIn?: string
  requestedClockOut?: string
  reasonCode?: string
} {
  const dto: {
    attendanceId: string
    reason: string
    requestedClockIn?: string
    requestedClockOut?: string
    reasonCode?: string
  } = {
    attendanceId,
    reason: data.reason.trim(),
  }
  if (data.reasonCode?.trim()) {
    dto.reasonCode = data.reasonCode.trim()
  }
  if (data.requestedClockInDate && data.requestedClockInTime) {
    dto.requestedClockIn = new Date(
      `${data.requestedClockInDate}T${data.requestedClockInTime}:00`
    ).toISOString()
  }
  if (data.requestedClockOutDate && data.requestedClockOutTime) {
    dto.requestedClockOut = new Date(
      `${data.requestedClockOutDate}T${data.requestedClockOutTime}:00`
    ).toISOString()
  }
  return dto
}
